import isEmpty from './isEmpty';
import isUndefinedOrNull from './isUndefinedOrNull';
/**
 * Returns true if the value is undefined, null or empty.
 *
 * NOTE: if you need empty, use isEmpty
 *
 * @param subject
 */
export default function isNullOrEmpty(subject) {
    if (isUndefinedOrNull(subject)) {
        return true;
    }
    return isEmpty(subject);
}
